<script setup lang="ts">
import RadButton from '../atoms/RadButton.vue';

interface Props {
  title: string;
  subtitle?: string;
  primaryButtonText: string;
  primaryButtonIcon?: string;
  secondaryButtonText?: string;
  backgroundGradient?: boolean;
}

withDefaults(defineProps<Props>(), {
  subtitle: '',
  primaryButtonIcon: '',
  secondaryButtonText: '',
  backgroundGradient: true,
});

defineEmits<{
  (e: 'primaryClick'): void;
  (e: 'secondaryClick'): void;
}>();
</script>

<template>
  <section class="py-20 px-4" :class="[
    backgroundGradient 
      ? 'bg-gradient-to-r from-rad-red/20 to-rad-blue/20' 
      : 'bg-white dark:bg-slate-900/50'
  ]">
    <div class="max-w-4xl mx-auto text-center">
      <h2 class="text-3xl md:text-4xl font-bold text-slate-900 dark:text-rad-white mb-6">
        {{ title }}
      </h2>
      <p v-if="subtitle" class="text-xl text-slate-600 dark:text-slate-400 mb-8 max-w-2xl mx-auto">
        {{ subtitle }}
      </p>
      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <RadButton
          size="lg"
          :icon="primaryButtonIcon"
          @click="$emit('primaryClick')"
        >
          {{ primaryButtonText }}
        </RadButton>
        <RadButton
          v-if="secondaryButtonText"
          variant="outline"
          size="lg"
          @click="$emit('secondaryClick')"
        >
          {{ secondaryButtonText }}
        </RadButton>
      </div>
    </div>
  </section>
</template>